export default function typeToString(type: 'PAPER' | 'ELECTRONIC' | null) {
  switch (type) {
    case 'PAPER':
      return '종이 계약';
    case 'ELECTRONIC':
      return '기타 전자계약';
    default:
      return '-';
  }
}
